<template lang="pug">
.faq-layout
  .container-fluid
    .row
      .d-none.d-md-block.col-md-4.col-xxl-3
        #sidebar
          FAQSidebar
      .col-sm-12.col-md-8.col-xxl-9
        .content
          .breadcrumb-password-view.pt-3.row
            Breadcrumb(:pathList='breadcrumbPathList')
          .title-installation-guide.text-start.mt-2.page--title
            h2 {{ pageName }}
          router-view
          Contact
</template>

<script lang="ts">
  import Contact from '@/components/Molecules/Contact.vue'
  import { defineComponent } from 'vue'
  import browserDeviceCheck from '@/utils/browserDeviceCheck'
  import FAQSidebar from '@/components/Organisms/FAQSidebar.vue'
  import Breadcrumb from '@/components/Molecules/Breadcrumbs.vue'

  export default defineComponent({
    name: 'FAQlayout',
    components: {
      Breadcrumb,
      Contact,
      FAQSidebar,
    },
    data: () => ({
      isMobile: false,
      pageName: '',
      breadcrumbPathList: {},
    }),
    watch: {
      $route() {
        this.setbreadcrumbPathList()
      },
    },
    mounted() {
      this.isMobile = browserDeviceCheck()
      this.setbreadcrumbPathList()
    },
    methods: {
      setbreadcrumbPathList() {
        this.pageName = this.$route.meta.pageName as string
        this.breadcrumbPathList = { Ajuda: 'faq', [this.pageName]: '#' }
      },
    },
  })
</script>

<style lang="stylus">
  #sidebar
    position: relative
    top: 0
    z-index: 4
    top: 0
    bottom: 0
    left: 0
    transition: left 0.3
    height: 100%
    border-right: 1px solid #CCCCCC
  .content
    padding: 1.2rem
  .code-box
    background-color: #F0F0F3
    padding: .5rem
    width: fit-content !important
    min-width: 550px !important
  .code-box--with-border
    border: 1px solid #A7A9B6
    width: auto !important
    min-width: 700px !important
  .red-background
    background-color: #f3bcb9
  .text
    font-size: 14px
  p
    font-size: 14px

  @media screen and (max-width: 1200px) {
    .code-box {
      width: 70% !important
    }
    .code-box--with-border {
      width: 90% !important
      min-width: 90% !important
    }
  }
  .page--title {
    font-size: 2rem !important;
  }
</style>
